// extracted by mini-css-extract-plugin
export var graph = "styles-module--graph--1GxKN";
export var origens = "styles-module--origens--35Cn0";
export var legenda = "styles-module--legenda--3pbY4";
export var legendaValor = "styles-module--legendaValor--3L9yb";
export var legendaOrigem = "styles-module--legendaOrigem--3oLyY";